import { ConsentCookie } from './consent-cookie';
import { resolveRegionOverrideFromSearch } from './region-client';
import type { Data } from './types';

/** Read-only bootstrap of an explicit choice persisted by an earlier visit.
 * Returns the same data `cookieManager.init()` would load from the cookie, or null
 * when there is no explicit choice yet: missing / invalid / unselected data, an
 * unsupported cookie version, a region override, or blocked storage. Null means
 * "undecided", never "declined". This never infers a new choice from geography,
 * changes consent, or starts network/UI work.
 */
export function readPersistedConsentData(): Data | null {
  try {
    if (typeof window === 'undefined' ||
        resolveRegionOverrideFromSearch(window.location.search)) return null;
    const stored = new ConsentCookie().read();
    if (stored?.v !== 1) return null;
    const { data } = stored;
    return (data.mode === 'opt_in' || data.mode === 'notice_only') && data.hasChoice === true ? data : null;
  } catch {
    return null;
  }
}

/** Whether an earlier visit explicitly allowed analytics. */
export function hasPersistedAnalyticsConsent(): boolean {
  return readPersistedConsentData()?.preference?.analytics === true;
}
